import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "cur-time-picker",
  templateUrl: "time-picker.html",
})
export class TimePickerComponent {
  @Input() time = { hour: 0, minute: 0 };

  @Input() disabled: boolean = false;
  @Input() includeSeconds: boolean = false;
  @Input() includeAmPm: boolean = false;
  @Output() valueChanged: EventEmitter<String> = new EventEmitter<String>();

  constructor() {}

  sendTime(e: Event) {
    this.valueChanged.emit(JSON.stringify(this.time));
  }
}



// WEBPACK FOOTER //
// ./src/components/common/time-picker/time-picker.ts